export default {
    data () {
        return {
            bankList: [
                {
                    value: "ABSA",
                    branch_code: "632005",
                }, {
                    value: "First National Bank",
                    branch_code: "250655",
                }, {
                    value: "Nedbank",
                    branch_code: "198765",
                }, {
                    value: "Standard Bank",
                    branch_code: "051001",
                }, {
                    value: "Capitec",
                    branch_code: "470010",
                }, {
                    value: "Investec",
                    branch_code: "580105",
                }, {
                    value: "Discovery Bank",
                    branch_code: "679000",
                }, {
                    value: "RMB",
                    branch_code: "254005",
                }, {
                    value: "African Bank",
                    branch_code: "430000",
                }, {
                    value: "Post Bank",
                    branch_code: "460005",
                }, {
                    value: "Bidvest Bank",
                    branch_code: "462005",
                }, {
                    value: "Citi Bank",
                    branch_code: "350005",
                }, {
                    value: "Mercantile Bank",
                    branch_code: "450105",
                }, {
                    value: "Grobank",
                    branch_code: "410506",
                }, {
                    value: "SA Post Office Bank",
                    branch_code: "460005",
                }, {
                    value: "Standard Chartered Bank",
                    branch_code: "730020",
                }, {
                    value: "Old Mutual Bank",
                    branch_code: "462005",
                }, {
                    value: "Bank Windhoek",
                    branch_code: "483872",
                }, {
                    value: "State Bank of India",
                    branch_code: "801000",
                }, {
                    value: "HBZ Bank Boksburg",
                    branch_code: "570100",
                }, {
                    value: "HBZ Bank Cape Town",
                    branch_code: "700066",
                }, {
                    value: "HBZ Bank Durban",
                    branch_code: "570126",
                }, {
                    value: "HBZ Bank Fordsburg",
                    branch_code: "570105",
                }, {
                    value: "HBZ Bank Lenasia",
                    branch_code: "570137",
                }, {
                    value: "HBZ Bank Pietermaritzburg",
                    branch_code: "570326",
                }, {
                    value: "HBZ Bank Pretoria",
                    branch_code: "570145",
                }, {
                    value: "HBZ Bank Vereeniging",
                    branch_code: "570101",
                }, {
                    value: "HBZ Bank Westville",
                    branch_code: "570226",
                }, {
                    value: "Albaraka Bank",
                    branch_code: "800000",
                }, {
                    value: "TymeBank",
                    branch_code: "678910",
                }, {
                    value: "Sasfin Bank",
                    branch_code: "683000",
                }, {
                    value: "Grindrod Bank Limited",
                    branch_code: "584000",
                }, {
                    value: "UBANK",
                    branch_code: "431010",
                }, {
                    value: "HSBC",
                    branch_code: "587000",
                }, {
                    value: "Olympus Mobile",
                    branch_code: "585001",
                }, {
                    value: "Barclays",
                    branch_code: "590000",
                }, {
                    value: "Finbond Mutual Bank",
                    branch_code: "589000",
                }, {
                    value: "Access Bank",
                    branch_code: "410506",
                }, {
                    value: "Bank Zero",
                    branch_code: "888000",
                },
            ]
        };
    },

    methods: {},
};
